import produce from 'immer';
import { format } from 'date-fns';
import { convertUTCDateToLocalDate } from 'helpers/date';
import { giftCodeDeliveryMethods } from 'helpers/giftCards';
import {
  GET_GIFT_CODES_LIST_FAILED,
  GET_GIFT_CODES_LIST_START,
  GET_GIFT_CODES_LIST_SUCCESS,
  GET_GIFT_CARD_HISTORY_START,
  GET_GIFT_CARD_HISTORY_SUCCESS,
  GET_GIFT_CARD_HISTORY_FAILED,
  GET_GIFT_CARD_TEMPLATES_START,
  GET_GIFT_CARD_TEMPLATES_SUCCESS,
  GET_GIFT_CARD_TEMPLATES_FAILED,
  CREATE_GIFT_CARD_CODE_START,
  CREATE_GIFT_CARD_CODE_SUCCESS,
  CREATE_GIFT_CARD_CODE_FAILED,
  GET_SINGLE_GIFT_CODE_FAILED,
  GET_SINGLE_GIFT_CODE_START,
  GET_SINGLE_GIFT_CODE_SUCCESS,
} from 'redux/actions/gift_card';


const initialState = {
  giftCodesList: [],
  giftCodesCSVData: [],
  giftCardHistory: [],
  giftCardTemplates: [],
  selectedGiftCode: null,
  giftCardHistoryCount: 0,
  giftCodesListCount: 0,
  isCreateGiftCodeLoading: false,
  isGiftCodeTemplatesLoading: false,
  isGiftCodesListLoading: false,
  isGiftCardHistoryLoading: false,
  isGiftCodeLoading: false
};

const formReducer = produce((state: IGiftCardState = initialState, action) => {
  switch (action.type) {
    case GET_GIFT_CODES_LIST_START: {
      if (!action.isCSVData) {
        state.isGiftCodesListLoading = true;
      }

      break;
    }
    case GET_GIFT_CODES_LIST_SUCCESS: {
      const { data: {giftCards}, isCSVData } = action;

      if (isCSVData) {
        state.giftCodesCSVData = giftCards.items.map((item) => ({
          'ID': item.giftcard_id,
          'Code': item.code,
          'Status': item.status_label,
          'Balance': item.balance,
          'Delivery': item.delivery_method ? giftCodeDeliveryMethods[item.delivery_method] : '',
          'Created Date': format(convertUTCDateToLocalDate(item.created_at), 'MM/dd/yyyy hh:mm:ss aa'),
          'Customer': item.customer_name
        }));
        return;
      }

      state.giftCodesList = giftCards.items;
      state.giftCodesListCount = giftCards.total_count;
      state.isGiftCodesListLoading = false;
      break;
    }
    case GET_GIFT_CODES_LIST_FAILED: {
      if (!action.isCSVData) {
        state.isGiftCodesListLoading = false;
      }

      break;
    }
    case GET_GIFT_CARD_HISTORY_START: {
      state.isGiftCardHistoryLoading = true;
      break;
    }
    case GET_GIFT_CARD_HISTORY_SUCCESS: {
      const { data: {history}} = action;

      state.giftCardHistory = history.items;
      state.giftCardHistoryCount = history.total_count;
      state.isGiftCardHistoryLoading = false;
      break;
    }
    case GET_GIFT_CARD_HISTORY_FAILED: {
      state.isGiftCardHistoryLoading = false;
      break;
    }
    case GET_GIFT_CARD_TEMPLATES_START: {
      state.isGiftCodeTemplatesLoading = true;
      break;
    }
    case GET_GIFT_CARD_TEMPLATES_SUCCESS: {
      const {data: {templates}} = action;

      const test = templates.items.map((item) => ({
        ...item,
        design: item.design ? JSON.parse(item.design) : [],
        images: item.images ? JSON.parse(item.images) : [],
      }));

      state.giftCardTemplates = test;
      state.isGiftCodeTemplatesLoading = false;
      break;
    }
    case GET_GIFT_CARD_TEMPLATES_FAILED: {
      state.isGiftCodeTemplatesLoading = false;
      break;
    }
    case CREATE_GIFT_CARD_CODE_START: {
      state.isCreateGiftCodeLoading = true;
      break;
    }
    case CREATE_GIFT_CARD_CODE_SUCCESS: {
      state.isCreateGiftCodeLoading = false;
      break;
    }
    case CREATE_GIFT_CARD_CODE_FAILED: {
      state.isCreateGiftCodeLoading = false;
      break;
    }
    case GET_SINGLE_GIFT_CODE_START: {
      state.isGiftCodeLoading = true;
      break;
    }
    case GET_SINGLE_GIFT_CODE_SUCCESS: {
      state.selectedGiftCode = action.data;
      state.isGiftCodeLoading = false;
      break;
    }
    case GET_SINGLE_GIFT_CODE_FAILED: {
      state.isGiftCodeLoading = false;
      break;
    }
    default:
      break;
  }
}, initialState);

export default formReducer;
